module.exports = {
    menus:["baosi"]
}